import { render, staticRenderFns } from "./BaseFieldDate.vue?vue&type=template&id=516b66f1&scoped=true"
import script from "./BaseFieldDate.vue?vue&type=script&lang=js"
export * from "./BaseFieldDate.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldDate.vue?vue&type=style&index=0&id=516b66f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b66f1",
  null
  
)

export default component.exports